import React from 'react';

/*
Props : 
views = 'views' <number>
*/
const DokanTableItemViews = ({ views }) => (
    <p className="text-xs text-tertiary">
        View: <span className="text-secondary">{views}</span>
    </p>
);

export default DokanTableItemViews;
